<template>
  <div class="space-y-4">
    <div class="flex justify-between items-center mb-4">
      <div class="h-5 bg-gray-200 rounded w-24 animate-pulse"></div>
      <div class="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
    </div>

    <div class="flex flex-col items-left gap-3 mb-4">
      <div class="w-14 h-14 bg-gray-200 rounded-full animate-pulse"></div>
      <div class="space-y-2">
        <div class="h-5 bg-gray-200 rounded w-32 animate-pulse"></div>
        <div class="h-4 bg-gray-200 rounded w-40 animate-pulse"></div>
      </div>
    </div>

    <div class="space-y-3">
      <div class="flex items-center justify-between">
        <div class="h-4 bg-gray-200 rounded w-12 animate-pulse"></div>
        <div class="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
      </div>

      <div class="flex items-center justify-between">
        <div class="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
        <div class="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
      </div>

      <div class="flex items-center justify-between">
        <div class="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
        <div class="h-6 bg-gray-200 rounded w-24 animate-pulse"></div>
      </div>

      <div class="flex items-center justify-between">
        <div class="h-4 bg-gray-200 rounded w-12 animate-pulse"></div>
        <div class="h-4 bg-gray-200 rounded w-10 animate-pulse"></div>
      </div>

      <div class="flex items-center justify-between">
        <div class="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
        <div class="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
      </div>

      <div class="flex items-center justify-between">
        <div class="h-4 bg-gray-200 rounded w-14 animate-pulse"></div>
        <div class="h-4 bg-gray-200 rounded w-12 animate-pulse"></div>
      </div>

      <div class="pt-2">
        <div class="h-4 bg-gray-200 rounded w-20 animate-pulse mb-2"></div>
        <div class="border border-grey p-4 rounded-sm">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-gray-200 rounded-full animate-pulse"></div>
              <div class="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
            </div>
            <div class="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div class="h-3 bg-gray-200 rounded w-48 animate-pulse"></div>
        </div>
      </div>
    </div>

    <div class="space-y-2 mt-6">
      <div class="h-10 bg-gray-200 rounded-sm animate-pulse"></div>
      <div class="h-10 bg-gray-200 rounded-sm animate-pulse"></div>
    </div>
  </div>
</template>